import styled from 'styled-components';
import { Table } from 'reactstrap';
import { Grid } from 'react-virtualized';
import { Switch } from 'takeat-design-system-ui-kit';

export const NavLinkSpan = styled.span`
  margin-right: 5px;
`;

export const SessionsTable = styled(Table)`
  width: 100%;
  align-items: center;
  border-collapse: separate;
  border-spacing: 0 20px;
  border-radius: 8px;
  padding: 20px;

  thead {
    border-bottom: 30px solid transparent;
    text-align: left;
    border-top: none;
    tr {
      th {
        color: #333;
        button {
          border: none;
          background-color: transparent;
          font-weight: bold;
          color: #333;
        }
      }

      th:last-child {
        text-align: right;
      }
    }
  }
  tbody {
    td {
      font-size: 16px;
      border-bottom: 1px solid #33333310;
      color: #333;
    }
    td:last-child {
      text-align: right;
    }

    tr:last-child {
      td {
        border-bottom: none;
      }
    }
  }
`;

export const Content = styled(Grid)`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  grid-gap: 20px;
  justify-items: center;
  margin-top: 20px;
  width: 100%;
  height: 100%;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  }
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 0 20px 20px;
  overflow: hidden;
  /* filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.1)); */
`;

export const TableContainer = styled.div`
  height: 100px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background-color: ${({ theme }) => theme.colors.green.dark};

  color: #ffffff;
  font-size: 20px;
  font-weight: 500;
`;

export const TablesAreaHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
`;

export const HeaderSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  label {
    gap: 0;

    span {
      font-size: 12px;
    }
  }
`;
